var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhoneCallsIconPrimary = function SvgPhoneCallsIconPrimary(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5455 12.2893C14.5455 13.5585 13.5232 14.5787 12.2727 14.5787C11.0223 14.5787 10 13.5585 10 12.2893C10 11.0202 11.0223 10 12.2727 10C13.5232 10 14.5455 11.0202 14.5455 12.2893Z",
    stroke: "#5656FC",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5455 19.868C14.5455 21.1371 13.5232 22.1573 12.2727 22.1573C11.0223 22.1573 10 21.1371 10 19.868C10 18.5988 11.0223 17.5786 12.2727 17.5786C13.5232 17.5786 14.5455 18.5988 14.5455 19.868Z",
    stroke: "#5656FC",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5455 27.4467C14.5455 28.7158 13.5232 29.736 12.2727 29.736C11.0223 29.736 10 28.7158 10 27.4467C10 26.1775 11.0223 25.1573 12.2727 25.1573C13.5232 25.1573 14.5455 26.1775 14.5455 27.4467Z",
    stroke: "#5656FC",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0904 12.2893C22.0904 13.5585 21.0681 14.5787 19.8176 14.5787C18.5672 14.5787 17.5449 13.5585 17.5449 12.2893C17.5449 11.0202 18.5672 10 19.8176 10C21.0681 10 22.0904 11.0202 22.0904 12.2893Z",
    stroke: "#5656FC",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0904 19.868C22.0904 21.1371 21.0681 22.1573 19.8176 22.1573C18.5672 22.1573 17.5449 21.1371 17.5449 19.868C17.5449 18.5988 18.5672 17.5786 19.8176 17.5786C21.0681 17.5786 22.0904 18.5988 22.0904 19.868Z",
    stroke: "#5656FC",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0904 27.4467C22.0904 28.7158 21.0681 29.736 19.8176 29.736C18.5672 29.736 17.5449 28.7158 17.5449 27.4467C17.5449 26.1775 18.5672 25.1573 19.8176 25.1573C21.0681 25.1573 22.0904 26.1775 22.0904 27.4467Z",
    stroke: "#5656FC",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6353 12.2893C29.6353 13.5585 28.613 14.5787 27.3626 14.5787C26.1121 14.5787 25.0898 13.5585 25.0898 12.2893C25.0898 11.0202 26.1121 10 27.3626 10C28.613 10 29.6353 11.0202 29.6353 12.2893Z",
    stroke: "#5656FC",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6353 19.868C29.6353 21.1371 28.613 22.1573 27.3626 22.1573C26.1121 22.1573 25.0898 21.1371 25.0898 19.868C25.0898 18.5988 26.1121 17.5786 27.3626 17.5786C28.613 17.5786 29.6353 18.5988 29.6353 19.868Z",
    stroke: "#5656FC",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6353 27.4467C29.6353 28.7158 28.613 29.736 27.3626 29.736C26.1121 29.736 25.0898 28.7158 25.0898 27.4467C25.0898 26.1775 26.1121 25.1573 27.3626 25.1573C28.613 25.1573 29.6353 26.1775 29.6353 27.4467Z",
    stroke: "#5656FC",
    strokeWidth: 2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneCallsIconPrimary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phoneCallsIconPrimary.549864f0.svg";
export { ForwardRef as ReactComponent };